<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContestStudent_editTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="data-value">
            <label>{{'bcContestStudent_lblFullName' | translate}}</label>
            <div>{{student?.FullName}}</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestStudent_lblProgram' | translate}}</label>
            <div>{{student?.Program}}</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestStudent_lblGrade' | translate}}</label>
            <div>{{student?.Grade | number}}</div>
        </div>

        <div class="form-field">
            <label class="form-label">{{'bcContestStudent_lblCustomGrade' | translate}}</label>
            <input class="form-control" [(ngModel)]="customGrade" type="number" min="0" step=".01" name="customGrade" />
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button">{{'dialog_close' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving || !form.valid">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>
</div>
